var _path, _path2, _g, _path3, _path4, _g2, _circle, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilePictureDefaultOver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7278_369714",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H100V100H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7278_369714)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7278_369714",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 50C100 53.2787 99.6654 56.5406 99.0298 59.7524C98.3941 62.9809 97.4406 66.1091 96.186 69.1368C94.9314 72.1646 93.3924 75.0418 91.5691 77.7852C89.7457 80.5119 87.6715 83.0378 85.3463 85.363C83.0211 87.6715 80.4951 89.7457 77.7685 91.5691C75.0418 93.3924 72.1646 94.9314 69.1201 96.186C66.0923 97.4573 62.9642 98.3941 59.7524 99.0465C56.5239 99.6822 53.2787 100 50 100C46.7046 100 43.4594 99.6822 40.2309 99.0465C37.0191 98.3941 33.8909 97.4573 30.8632 96.186C27.8187 94.9314 24.9415 93.3924 22.2148 91.5691C19.4881 89.7457 16.9622 87.6715 14.637 85.363C12.3118 83.0378 10.2375 80.5119 8.41419 77.7852C6.59084 75.0418 5.05186 72.1646 3.79726 69.1368C2.54266 66.1091 1.58916 62.9809 0.953496 59.7524C0.317834 56.5406 0 53.2787 0 50C0 46.7213 0.317834 43.4593 0.953496 40.2476C1.58916 37.0191 2.54266 33.8909 3.79726 30.8632C5.05186 27.8354 6.59084 24.9582 8.41419 22.2148C10.2375 19.4881 12.3118 16.9622 14.637 14.637C16.9622 12.3285 19.4881 10.2543 22.2148 8.43091C24.9415 6.60756 27.8187 5.06859 30.8632 3.81398C33.8909 2.54266 37.0191 1.60589 40.2309 0.953494C43.4594 0.317832 46.7046 0 50 0C53.2787 0 56.5239 0.317832 59.7524 0.953494C62.9642 1.60589 66.0923 2.54266 69.1201 3.81398C72.1646 5.06859 75.0418 6.60756 77.7685 8.43091C80.4951 10.2543 83.0211 12.3285 85.3463 14.637C87.6715 16.9622 89.7457 19.4881 91.5691 22.2148C93.3924 24.9582 94.9314 27.8354 96.186 30.8632C97.4406 33.8909 98.3941 37.0191 99.0298 40.2476C99.6654 43.4593 100 46.7213 100 50Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7278_369714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0V100H100V0H0Z",
    fill: "#F2F0FF"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7278_369714",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 17,
    width: 69,
    height: 65
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.373 17.4639H83.8909V81.6994H15.373V17.4639Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7278_369714)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7278_369714",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 19,
    width: 64,
    height: 62
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.724 61.9389L72.8839 70.2694C72.8504 71.5742 72.5828 72.8288 72.081 74.0165C71.5791 75.2209 70.8598 76.2915 69.9398 77.2115C69.0365 78.1316 67.9659 78.8676 66.7782 79.3862C65.5905 79.9048 64.3359 80.1724 63.0311 80.2226C61.7263 80.256 60.4717 80.0553 59.2506 79.6037C58.0127 79.152 56.9254 78.4996 55.9552 77.6297C54.9849 76.7432 54.2154 75.7228 53.63 74.5685C53.0612 73.3976 52.7267 72.1597 52.6263 70.8549C51.8401 70.2862 50.9535 70.0185 49.9833 70.0185C49.013 70.0185 48.1432 70.2862 47.357 70.8549C45.9685 83.6184 27.7517 83.0998 27.0826 70.2694L25.2593 62.0225C25.1589 61.5876 25.2425 61.1694 25.4767 60.8014C25.7277 60.4166 26.0622 60.1824 26.5139 60.0821C26.9488 59.9817 27.3503 60.0486 27.735 60.2828C28.1198 60.5337 28.354 60.8683 28.4711 61.3032L29.09 64.0466C30.2442 62.5076 31.7163 61.3869 33.5062 60.6843C35.2961 59.9817 37.1362 59.7977 39.0264 60.149C40.9334 60.4835 42.5895 61.3032 44.0281 62.5913C45.45 63.8793 46.4369 65.435 46.989 67.2918C48.9796 66.4387 50.9869 66.4387 52.9776 67.2918C53.5129 65.435 54.4998 63.8459 55.9384 62.5578C57.3603 61.253 59.0331 60.4334 60.9401 60.0988C62.8304 59.7642 64.6872 59.9482 66.4771 60.6508C68.267 61.3701 69.739 62.5076 70.8933 64.0633L71.5122 61.2196C71.6126 60.7679 71.8635 60.4334 72.2482 60.1824C72.633 59.9482 73.0345 59.8646 73.4861 59.965C73.9378 60.0653 74.2723 60.3163 74.5232 60.701C74.7574 61.0858 74.8243 61.504 74.724 61.9389ZM73.553 39.8579C74.0716 40.962 74.8076 42.4842 73.3356 43.2537C72.9174 43.4712 72.4824 43.5046 72.0475 43.3373C71.5958 43.1868 71.278 42.8857 71.094 42.4675C68.5179 36.4621 66.8953 31.9623 63.5329 23.3139C63.1315 22.2768 62.4791 21.4404 61.559 20.788C60.6557 20.1523 59.6353 19.8178 58.5145 19.801C56.2395 19.5836 53.0947 22.2768 51.2211 23.2972C50.4349 23.7823 49.6487 23.7823 48.8792 23.2972L44.5467 20.604C43.8441 20.1691 43.1081 19.9181 42.2884 19.8178C41.4854 19.7174 40.6992 19.801 39.9297 20.052C39.1602 20.3029 38.4744 20.7044 37.8889 21.2564C37.2867 21.8084 36.8351 22.4608 36.5339 23.2136C35.4132 25.9737 29.7926 40.0921 28.8056 42.5177C28.6718 42.9693 28.3874 43.2872 27.9692 43.5046C27.551 43.7054 27.1161 43.7221 26.6812 43.5715C26.2462 43.4043 25.9284 43.1199 25.7444 42.685C25.5436 42.2668 25.5436 41.8318 25.7109 41.4136L25.7611 41.2965L26.3131 39.8914C22.2482 41.3802 18.7354 43.605 18.7354 46.8837C18.8692 60.6676 81.1308 60.6676 81.2479 46.8837C81.2479 43.5883 77.6848 41.3467 73.553 39.8579Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7278_369714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7354 19.583V83.6178H81.2479V19.583H18.7354Z",
    fill: "url(#paint0_linear_7278_369714)"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#7043FF",
    fillOpacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 38C50.6414 38 51.1613 38.5199 51.1613 39.1613V48.8387H60.8387C61.4801 48.8387 62 49.3586 62 50C62 50.6414 61.4801 51.1613 60.8387 51.1613H51.1613V60.8387C51.1613 61.4801 50.6414 62 50 62C49.3586 62 48.8387 61.4801 48.8387 60.8387V51.1613H39.1613C38.5199 51.1613 38 50.6414 38 50C38 49.3586 38.5199 48.8387 39.1613 48.8387H48.8387V39.1613C48.8387 38.5199 49.3586 38 50 38Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7278_369714",
    x1: 18.7427,
    y1: 49.9947,
    x2: 81.2422,
    y2: 49.9947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#01BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#02BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#02BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#03BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#04BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#04BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#05BAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#06B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#06B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#07B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#08B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "#08B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#09B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#0AB4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#0AB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#0BB3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#0CB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#0CB1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#0DB0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "#0EAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#0EAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#0FAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#10ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "#10ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#11ABFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#12AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#12AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#13A9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#14A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#14A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#15A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#16A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#16A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#17A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#18A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "#18A2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#19A2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#1AA1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#1AA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#1B9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#1C9EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "#1C9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#1D9DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#1E9CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#1E9BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#1F9AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#2099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#2099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#2198FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#2197FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#2296FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414062,
    stopColor: "#2395FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#2395FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429687,
    stopColor: "#2494FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#2593FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#2592FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#2691FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#2790FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#2790FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#288FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#298EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#298DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2A8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#2B8CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#2B8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#2C8AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#2D89FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#2D88FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#2E88FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#2F87FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#2F86FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#3085FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#3184FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#3183FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#3283FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#3382FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#3381FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#3480FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#357FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#357FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#367EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#377DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#377CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#387BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#397BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#397AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#3A79FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "#3B78FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#3B77FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#3C76FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#3D76FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#3D75FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#3E74FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#3F73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3F72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757812,
    stopColor: "#4072FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#4171FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#4170FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#426FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#436EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#436EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "#446DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#456CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820312,
    stopColor: "#456BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#466AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#4769FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#4769FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "#4868FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#4967FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#4966FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#4A65FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "#4B65FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#4B64FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#4C63FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#4D62FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914063,
    stopColor: "#4D61FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#4E61FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#4F60FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#4F5FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#505EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#515DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#515CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#525CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976562,
    stopColor: "#535BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#535AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992188,
    stopColor: "#5459FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5558FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePictureDefaultOver);
export default __webpack_public_path__ + "static/media/profilePictureDefaultOver.c592bf32d2ae7a6552975196951e9192.svg";
export { ForwardRef as ReactComponent };